module.exports = __webpack_public_path__ + "media/images/icons/flags/CM-d56db240f0c3237bbf8bf1087337d151.svg";